export default __webpack_public_path__ + "static/media/Download-App-Store.e918ff18.png";